import './src/styles/global.scss';
import './src/styles/common.scss';
import EmailProvider from "./src/context/EmailProvider";

export const wrapRootElement = EmailProvider